import React, { useRef } from 'react'
import { motion, useInView } from "framer-motion";
import './aboutCompany.css';

function AboutCompany() {

  const card1Ref = useRef(null);
  const card1InView = useInView(card1Ref);

  const card2Ref = useRef(null);
  const card2InView = useInView(card2Ref);

  const card3Ref = useRef(null);
  const card3InView = useInView(card3Ref);

  return (
    <>

      <section className="about-section" id="about">
        <div className="container">

          <div className="row">
            {/* كارت 1 - التعريف بالشركة */}
            <div className="col-lg-4 col-md-6 cardContainer d-flex justify-content-center">
              <motion.div
                ref={card1Ref}
                initial={{ opacity: 0, x: 30 }}
                animate={card1InView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
                transition={{ duration: 0.4, delay: 0.3 }}
              >
                <div className="card about-card w-100 h-100">
                  <div className="icon-box">
                    <i className="bi bi-building" style={{ fontSize: '3rem', color: '#0f4837' }}></i>
                  </div>
                  <div className="card-content">
                    <div className="card-details">
                      <h2>من نحن</h2>
                      <div className="card-description">
                        شركة هندسية متكاملة متخصصة في مجال التصميم والتنفيذ المعماري والهندسي ، نسعى لتقديم حلول مبتكرة وعالية الجودة تلبي احتياجات عملائنا في القطاعين العام والخاص .
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* كارت 2 - الفريق */}
            <div className="col-lg-4 col-md-6 cardContainer d-flex justify-content-center">
              <motion.div
                ref={card2Ref}
                initial={{ opacity: 0, x: 30 }}
                animate={card2InView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
                transition={{ duration: 0.4, delay: 0.4 }}
              >
                <div className="card about-card w-100 h-100">
                  <div className="icon-box">
                    <i className="bi bi-people-fill" style={{ fontSize: '3rem', color: '#0f4837' }}></i>
                  </div>
                  <div className="card-content">
                    <div className="card-details">
                      <h2>فريق العمل</h2>
                      <div className="card-description">
                        تتميز شركتنا بفريق عمل متنوع يضم نخبة من المهندسين الاستشاريين والخبراء المؤهلين في مجالات العمارة والهندسة المدنية والميكانيكية والكهربائية إضافة إلى مختصين في إدارة المشاريع
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* كارت 3 - التميز والاحترافية */}
            <div className="col-lg-4 col-md-6 cardContainer d-flex justify-content-center">
              <motion.div
                ref={card3Ref}
                initial={{ opacity: 0, x: 30 }}
                animate={card3InView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
                transition={{ duration: 0.4, delay: 0.4 }}
              >
                <div className="card about-card w-100 h-100">
                  <div className="icon-box">
                    <i className="bi bi-award-fill" style={{ fontSize: '3rem', color: '#0f4837' }}></i>
                  </div>
                  <div className="card-content">
                    <div className="card-details">
                      <h2>ما يميزنا</h2>
                      <div className="card-description">
                        نعمل باحترافية عالية بفضل كوادرنا المؤهلة، لنقدم خدمات هندسية متكاملة تلبي احتياجات مختلف القطاعات.
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

          </div>
        </div>
      </section>


    </>
  );
}

export default AboutCompany;
